"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
const defaultHeadingElements = /* @__PURE__ */ new Map([
  ["1", "h1"],
  ["2", "h2"],
  ["3", "h3"],
  ["4", "h4"],
  ["5", "h5"]
]);
export const Heading = forwardRef(
  (_a, ref) => {
    var _b = _a, { element, level, strong, secondary, align, theme = "light", className, id, children } = _b, rest = __objRest(_b, ["element", "level", "strong", "secondary", "align", "theme", "className", "id", "children"]);
    const defaultElement = defaultHeadingElements.get(level);
    const HeadingElement = element || defaultElement || "span";
    return /* @__PURE__ */ React.createElement(
      HeadingElement,
      __spreadValues({
        id,
        className: classNames("kl-heading", className, `kl-heading--level-${level}`, {
          "kl-heading--dark": theme === "dark",
          "kl-heading--strong": strong,
          "kl-heading--secondary": secondary,
          [`kl-heading--align-${align}`]: align
        }),
        ref
      }, rest),
      children
    );
  }
);
